<app-navigation></app-navigation>
<main id="start" class="fake-body" style="padding-top: 100px">
  <!-- <section id="hero" class="why-choose-us-hero">
    <div class="container">
      <div class="row d-flex align-items-center">
        <div class="col-md-7">
          <h1 class="">
            Comparisons
          </h1>
          <p style="font-weight: normal;
          font-size: 28px;
          color: #485364;
          display: block;
          margin-top: 8px;
          line-height: 42px;">We are here to help you with a practical comparison against alternatives that you may be using today or evaluating (versus the marketing-speak found on other sites).</p>
        </div>
        <div class="col-md-5">
          <img class="img-responsive" src="assets/img/landing-page-v4/comparison.jpg" alt="Image of a man thinking">
        </div>
      </div>
      
    </div>
  </section> -->

  <!-- <div class="tabs text-center">
    <a [ngClass]="{'active': comparisonTab == 'simple'}" (click)="comparisonTab = 'simple'">Simple</a>
    <a [ngClass]="{'active': comparisonTab == 'detailed'}" (click)="comparisonTab = 'detailed'">Detailed</a>
  </div> -->

  <section
    id="comparisons-page"
    [ngClass]="{ hidden: comparisonTab == 'detailed' }"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <div class="table-of-contents">
            <label>
              Click a product from the list below to compare with Client Hub:
            </label>
            <a
              [routerLink]="['/comparisons', 'karbon']"
              [ngClass]="{ selected: app == 'karbon' }"
              >Karbon</a
            >
            <a
              [routerLink]="['/comparisons', 'jetpack-workflow']"
              [ngClass]="{ selected: app == 'jetpack-workflow' }"
              >JetPack Workflow</a
            >
            <!-- <a [routerLink]="['/comparisons', 'senta']" [ngClass]="{'selected': app == 'senta'}">Senta</a> -->
            <a
              [routerLink]="['/comparisons', 'clickup']"
              [ngClass]="{ selected: app == 'clickup' }"
              >ClickUp</a
            >
            <a
              [routerLink]="['/comparisons', 'asana']"
              [ngClass]="{ selected: app == 'asana' }"
              >Asana</a
            >
            <a
              [routerLink]="['/comparisons', 'financial-cents']"
              [ngClass]="{ selected: app == 'financial-cents' }"
              >Financial Cents</a
            >
            <!-- <a [routerLink]="['/comparisons', 'pixie']" [ngClass]="{'selected': app == 'pixie'}">Pixie</a> -->
            <a
              [routerLink]="['/comparisons', 'liscio']"
              [ngClass]="{ selected: app == 'liscio' }"
              >Liscio</a
            >
          </div>
        </div>
        <div class="col-md-9">
          <div *ngIf="app == 'karbon'">
            <h1 style="margin-top: 0">
              Why choose Client Hub over {{ appName }}
            </h1>
            <h3 style="margin-top: 0">
              If you’re looking to understand the difference between
              {{ appName }} and Client Hub, you’re in the right place.
            </h3>
            <p>
              First, we’d like to acknowledge the team at {{ appName }}. They
              have developed a very good workflow system to help accounting and
              bookkeeping firms.
            </p>
            <p>
              Client Hub is a workflow system
              <strong>with Client Collaboration built-in</strong>, which goes
              beyond just tracking your work and deadlines. With Client Hub’s
              amazing client experience and mobile app, you always have what you
              need from clients to get your work done.
            </p>
            <p>
              And for your clients on QuickBooks Online, our powerful QuickBooks
              integration automates resolving uncategorized transactions, saving
              your team hours of time.
            </p>
            <p>
              In short, by including clients and client experience in your
              workflow system, we take {{ appName }} to the next level.
            </p>

            <!-- <h2>{{ appName }} was a pioneer.
              <br>We’re the next generation.
            </h2>
            <p>We’re the next generation.
              {{ appName }} was one of the first practice management systems that was built for accounting
              professionals. It
              has been a pioneer in our industry and now has a focus on larger firms that have very complex
              requirements.
            </p>
            <p>We’re reimaging your firm’s work in an approachable, client-centric way -- on a workflow system that is
              designed from the ground up for both your internal team and your clients.</p>
            <p>Because your clients are part of your workflow, everything flows seamlessly. You’re never blocked
              “waiting for clients”. Client Hub is a modern, fresh, all-in-one platform: Workflow, Client Communication,
              Client Portal, File Sharing, Mobile Apps and more.</p> -->

            <h3>So what sets Client Hub apart from {{ appName }}?</h3>
            <p>
              Here are nine ways that Client Hub takes {{ appName }} to the next
              level.
            </p>

            <div class="features-items">
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/qbo-integration.svg"
                    class="qbo-icon"
                    alt="Unique QuickBooks Integration"
                  />
                  <h3>Unique QuickBooks Integration</h3>
                  <p>Instantly resolve uncategorized transactions.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/mobile-app.svg"
                    alt="Mobile Apps"
                  />
                  <h3>Mobile Apps</h3>
                  <p>Game-changing for your team and your clients.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/modern-experience.svg"
                    alt="Modern Experience"
                  />
                  <h3>Modern Experience</h3>
                  <p>Staff and clients love our fresh, approachable design.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/client-communication.svg"
                    alt="Client Communication Built-in"
                  />
                  <h3>Client Communication Built-in</h3>
                  <p>So much better than cluttered email inboxes.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/secure-file-sharing.svg"
                    alt="File Sharing Built-in"
                  />
                  <h3>File Sharing Built-in</h3>
                  <p>
                    Internal files and client-facing files, all organized with
                    folders.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/modern-client-portal.svg"
                    alt="Client Portal Built-in"
                  />
                  <h3>Client Portal Built-in</h3>
                  <p>Clients access everything they need right from here.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/innovation.svg"
                    alt="Rapid Innovation"
                  />
                  <h3>Rapid Innovation</h3>
                  <p>
                    Always delighting customers with new capabilities based on
                    your input.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/secure-communication.svg"
                    alt="Secure Communication"
                  />
                  <h3>Secure Communication</h3>
                  <p>Email is just not secure. Don’t risk your firm.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/small-team.svg"
                    alt="Small Team, Personal Service"
                  />
                  <h3>Small Team, Personal Service</h3>
                  <p>You’re working with the founders.</p>
                </div>
              </div>
            </div>

            <div class="video-quote" style="margin: 64px 0">
              <div class="row">
                <div class="col-md-8">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/r9UdUu6aLak"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <p>April Miller, Sand Dollar Bookkeeping</p>
                </div>
                <div class="col-md-4">
                  <h2>
                    Hear about how Sand Dollar Bookkeeping’s client gets them
                    what they need through Client Hub -- and loves doing it!
                  </h2>
                </div>
              </div>
            </div>

            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>Communicate without the clutter of email boxes</h3>
                  <p class="check-icon">
                    With Client Hub’s conversation panel and mobile apps, your
                    clients and your team communicate everywhere with a
                    delightful experience.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, clients are stuck communicating with you
                    through their cluttered email boxes. And on your side, your
                    business emails can now only be triaged in
                    {{ appName }} (and not in mobile apps).
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/conversations.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>A client experience that reflects a modern firm</h3>
                  <p class="check-icon">
                    With Client Hub’s modern experience and mobile apps, you
                    stand out for your modern client service.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, your firm is like any other. They
                    suggest Liscio for client experience (more subscription $
                    and more systems for you to maintain).
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/client-experience.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>No more blocked work that’s “waiting for client”</h3>
                  <p class="check-icon">
                    With Client Hub’s Client Tasks panel available online and in
                    our mobile app, your clients can answer you everywhere with
                    a delightful experience.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, your clients are only notified through
                    their cluttered email boxes and have to click through to
                    their tasks.
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/no-waiting-for-clients.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>No need for additional apps</h3>
                  <p class="check-icon">
                    With Client Hub, client portal and file sharing is built-in.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, you need additional apps for these key
                    needs.
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/no-additional-apps.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <h2>We’re simply a more collaborative and complete platform</h2>
            <h3 class="text-center">What we do…</h3>
            <div class="row">
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/client-hub.svg"
                  alt="Client Hub's features Chart"
                />
              </div>
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/{{ app }}.svg"
                  alt="{{ appName }}'s features Chart"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h3 class="text-center" style="margin-bottom: 32px">
                  How We Do It…
                </h3>
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="text-center">Client Hub</h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/ch-experience.svg"
                      alt="Client Hub's Experience"
                    />
                  </div>
                  <div class="col-md-6">
                    <h4 class="text-center">
                      {{ appName }}
                    </h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/{{
                        app
                      }}-experience.svg"
                      alt="{{ appName }}'s Experience"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="section-title text-center" style="margin-top: 80px">
              <h2>Save Big With Client Hub</h2>
              <p>
                Client Hub replaces a bunch of apps. See how our all-in-one
                solution compares to the cost (not to mention complexity) of
                bundling together a comparable “tech stack”.
              </p>
            </div>
            <div class="save-big text-left save-big-wrapper">
              <div class="row">
                <div class="col-md-5">
                  <div class="save-big-box-wrapper">
                    <div class="save-big-box no-plus">
                      <div class="icon">
                        <svg
                          width="41"
                          height="43"
                          viewBox="0 0 41 43"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M39.9505 5.4977C39.1937 1.78237 35.5732 -0.619247 31.8709 0.14024C28.1686 0.899726 25.7753 4.53295 26.5322 8.24827C26.6753 8.98723 26.9822 9.66461 27.3299 10.2804L24.6708 14.3242C23.3617 13.9957 21.9707 13.9136 20.5594 14.201C18.8616 14.55 17.4093 15.371 16.2229 16.4589L12.0501 13.6673C12.2138 12.8873 12.2138 12.0662 12.0501 11.2452C11.3751 7.94037 8.16372 5.8056 4.87049 6.48298C1.57726 7.18089 -0.550043 10.4036 0.124966 13.7084C0.799976 17.0132 4.01139 19.1479 7.30462 18.4706C8.12281 18.3063 8.87964 17.9779 9.51374 17.5263L13.6865 20.2974C13.1547 21.8164 12.9911 23.4996 13.3388 25.1828C13.707 27.0096 14.6274 28.5902 15.8547 29.8218L14.157 32.3876C13.4615 32.2234 12.7456 32.1824 11.9888 32.3261C9.1251 32.9213 7.26371 35.7335 7.83644 38.6277C8.42963 41.5015 11.2319 43.3694 14.1161 42.7947C16.9798 42.1994 18.8411 39.3872 18.2684 36.493C18.1252 35.7335 17.7775 35.0972 17.3479 34.5019L19.0457 31.9361C20.6616 32.5724 22.4617 32.8187 24.2821 32.4287C29.2936 31.4024 32.5459 26.476 31.5027 21.4469C31.2163 20.0306 30.6027 18.7785 29.764 17.6905L32.4232 13.6468C33.1391 13.7289 33.855 13.7289 34.5914 13.5852C38.3142 12.8462 40.7074 9.21303 39.9505 5.4977ZM6.52733 14.6731C5.3205 14.94 4.13411 14.1394 3.88866 12.9284C3.6432 11.7173 4.42048 10.5267 5.62732 10.2804C6.83415 10.0341 8.02053 10.8141 8.26599 12.0252C8.51145 13.2363 7.73417 14.4268 6.52733 14.6731ZM13.5024 39.7772C12.2751 40.0236 11.0888 39.2435 10.8433 38.0119C10.5978 36.7803 11.3751 35.5898 12.6024 35.3435C13.8297 35.0972 15.0161 35.8772 15.2615 37.1088C15.5275 38.3198 14.7297 39.5104 13.5024 39.7772ZM23.3617 27.9128C20.8253 28.426 18.3502 26.7839 17.8389 24.2385C17.3275 21.6932 18.9639 19.2095 21.5003 18.6963C24.0367 18.1832 26.5117 19.8253 27.0231 22.3706C27.5345 24.9159 25.8981 27.3997 23.3617 27.9128ZM33.7323 9.25408C32.4232 9.52093 31.1345 8.67933 30.8686 7.36563C30.6027 6.05192 31.4413 4.75874 32.7504 4.49189C34.0595 4.22505 35.3482 5.06664 35.6141 6.38035C35.88 7.69405 35.0414 8.98723 33.7323 9.25408Z"
                            fill="#0075FF"
                          />
                        </svg>
                      </div>
                      <div class="save-big-text">
                        <h4>Client Hub</h4>
                        <p>$49 - $59/month per user</p>
                      </div>
                    </div>
                    <div class="features">
                      <div class="plan-features">
                        <ul>
                          <li>Simple client messaging</li>
                          <li>Assign and track client tasks</li>
                          <li>QuickBooks categorization tasks</li>
                          <li>Secure client file-sharing</li>
                          <li>Manage Internal files</li>
                          <li>Client apps & resources</li>
                          <li>Mobile app access</li>
                          <li>Your firm branding</li>
                          <li>And much, much more…</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 text-center flex-center">
                  <div class="vs">VS</div>
                </div>
                <div class="col-md-6">
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.2924 0.419922C22.1431 0.419922 22.8319 1.11306 22.8319 1.96891V10.489L29.9988 3.27848C30.6004 2.67357 31.5748 2.67357 32.1766 3.27848C32.7776 3.88354 32.7776 4.86438 32.1766 5.46929L22.8319 14.8707V19.1274L34.7751 7.15781C35.3777 6.55359 36.3525 6.55537 36.9525 7.16179C37.5527 7.76808 37.5509 8.74837 36.9487 9.35247L22.8319 23.5005V28.014L38.0576 12.6953C38.659 12.0908 39.6337 12.0908 40.2351 12.6953C40.8364 13.3008 40.8364 14.2811 40.2351 14.8866L34.1681 20.991L40.2715 27.1319C40.8729 27.7369 40.8729 28.7177 40.2715 29.3226C39.9706 29.625 39.5765 29.7763 39.1829 29.7763C38.7887 29.7763 38.3946 29.625 38.0941 29.3226L31.9901 23.1818L29.5491 25.6381L36.7159 32.8487C37.3168 33.4537 37.3168 34.4344 36.7159 35.0395C36.4151 35.3417 36.0209 35.493 35.6268 35.493C35.233 35.493 34.8389 35.3417 34.538 35.0395L27.3713 27.8289L24.9302 30.2852L31.4921 36.8873C32.0931 37.4922 32.0931 38.473 31.4921 39.0781C31.1913 39.3803 30.7971 39.5317 30.403 39.5317C30.0093 39.5317 29.6152 39.3803 29.3143 39.0781L22.8319 32.5561V40.0309C22.8319 40.8864 22.1431 41.5799 21.2924 41.5799C20.4421 41.5799 19.7526 40.8864 19.7526 40.0309V1.96891C19.7526 1.11306 20.4421 0.419922 21.2924 0.419922V0.419922ZM15.1341 1.30486C15.9844 1.30486 16.6736 1.99841 16.6736 2.85385V39.1454C16.6736 40.001 15.9844 40.6946 15.1341 40.6946C14.2838 40.6946 13.5944 40.001 13.5944 39.1454V2.85385C13.5944 1.99841 14.2838 1.30486 15.1341 1.30486V1.30486ZM8.97549 4.84545C9.82578 4.84545 10.5151 5.53899 10.5151 6.39457V35.6049C10.5151 36.4603 9.82578 37.1539 8.97549 37.1539C8.1252 37.1539 7.43592 36.4603 7.43592 35.6049V6.39457C7.43592 5.53899 8.1252 4.84545 8.97549 4.84545V4.84545ZM2.81692 15.4675C3.66735 15.4675 4.35663 16.161 4.35663 17.0165V24.983C4.35663 25.8384 3.66735 26.532 2.81692 26.532C1.96663 26.532 1.27734 25.8384 1.27734 24.983V17.0165C1.27734 16.161 1.96663 15.4675 2.81692 15.4675Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Karbon (or JetPack/FinancialCents etc.): workflow</h4>
                      <p>$49 - $59/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/liscio.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Liscio: client communication and tasks</h4>
                      <p>$50/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.5 3.1499L21 9.84365L10.5 16.5374L0 9.84365L10.5 3.1499V3.1499ZM31.5 3.1499L42 9.84365L31.5 16.5374L21 9.84365L31.5 3.1499V3.1499ZM0 23.2312L10.5 16.5374L21 23.2312L10.5 29.9249L0 23.2312V23.2312ZM31.5 16.5374L42 23.2312L31.5 29.9249L21 23.2312L31.5 16.5374V16.5374ZM10.5 32.1562L21 25.4624L31.5 32.1562L21 38.8499L10.5 32.1562Z"
                          fill="#3A4D97"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Dropbox for Teams (or Sharefile etc.): files</h4>
                      <p>$15/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg no-plus">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/uncat.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Uncat: QuickBooks uncategorized automation</h4>
                      <p>$5/month per client</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h2 class="text-center">We’ll help you evaluate and switch</h2>
            <p class="text-center">
              Get all your questions answered. Schedule a 1/1 demo
              <a (click)="openModal(demoScheduleModal)" target="_blank" rel="noreferrer noopener">here</a
              >.
            </p>

            <div class="row fix-mobile">
              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      SO THANKFUL<br />
                      <p style="font-weight: normal">CortnieG</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    The app is new, but they seem totally interested in making
                    it better and better! I have not even been a client a year
                    and I have had such a great experience overall!!!! I am
                    happy to call myself an excited and HAPPY customer and in
                    turn made a great experience for my firm. I highly recommend
                    it and would be willing to help anyone out if they had any
                    questions!! I cant wait to see what this product becomes!!
                    It is getting better and better as we go!!!!!!! (AND MY
                    CLEINTS LOVE IT TOO!)
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      EXACTLY what my firm needed<br />
                      <p style="font-weight: normal">eControllerPlus</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I am blown away by this app! Everything at my fingertips and
                    everything at my clients' fingertips as well! I have moved
                    ALL client communications here and it couldn't be easier to
                    navigate our conversations. The ability to share docs with
                    clients and staff OR staff ONLY is brilliant. Wish I had
                    integrated this earlier!!
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      THE best acct practice software on the market
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I've been struggling for years to find the right combination
                    of software that would allow me and my team to manage all of
                    our bookkeeping clients from one location. The QuickBooks
                    team area works great for QuickBooks clients, but for all my
                    desktop/other accounting application clients, it just didn't
                    cut it. Client Hub does. With chat, file storage, QuickBooks
                    integration, and task lists as features, this has everything
                    I need to provide a full-service bookkeeping experience for
                    all my clients. Client Hub also allows you to "bookmark"
                    client-specific links - like to their banking applications,
                    third party software, and firm-developed applications.
                    Absolutely fantastic.
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center" style="margin-top: 30px">
              <div class="reviews-app row d-flex align-items-center">
                <div class="col-md-6 text-right">
                  <a
                    href="https://quickbooks.intuit.com/app/apps/appdetails/ClientHub/en-us//"
                    target="_blank" rel="noreferrer noopener"
                    class="btn btn-success"
                    >See all our app reviews</a
                  >
                </div>
                <div class="col-md-6 text-left">No Reviews Filtered Out</div>
              </div>
            </div>

            <div class="big-cta orange">
              <div class="row">
                <div class="col-sm-3 col-md-3 cta-illustration">
                  <img
                    src="assets/img/landing-page-v4/billy-cta-2.png"
                    alt="Image of an accountant"
                  />
                </div>
                <div class="col-sm-5 col-md-6">
                  <div class="title">No More Waiting for Clients!</div>
                </div>
                <div class="col-sm-3 col-md-3 text-right">
                  <button class="btn btn-orange" (click)="startRegistration()">
                    Start Trial
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Karbon -->

          <div *ngIf="app == 'jetpack-workflow'">
            <!-- 1 -->
            <h1 style="margin-top: 0">
              Why choose Client Hub over {{ appName }}
            </h1>
            <h3 style="margin-top: 0">
              If you’re looking to understand the difference between Jetpack
              Workflow and Client Hub, you’re in the right place.
            </h3>
            <p>
              First, we’d like to acknowledge the team at Jetpack Workflow. They
              have developed a very good workflow system to help accounting and
              bookkeeping firms.
            </p>
            <p>
              Client Hub is a workflow system
              <strong>with Client Collaboration built-in</strong>, which goes
              beyond just tracking your work and deadlines. With Client Hub’s
              amazing client experience and mobile app, you always have what you
              need from clients to get your work done.
            </p>
            <p>
              And for your clients on QuickBooks Online, our powerful QuickBooks
              integration automates resolving uncategorized transactions, saving
              your team hours of time.
            </p>
            <p>
              In short, by including clients and client experience in your
              workflow system, we take Jetpack Workflow to the next level.
            </p>

            <!-- 2 -->
            <!-- <h2>{{ appName }} was a pioneer.
              <br>We’re the next generation.
            </h2>
            <p>{{ appName }} was one of the first practice management systems that was built for accounting
              professionals. It has been a pioneer in our industry but has remained focused just on managing deadlines
              and assignments.
            </p>
            <p>We’re reimaging your firm’s work in an approachable, client-centric way -- on a workflow system that is
              designed from the ground up for both your internal team and your clients.</p>
            <p>Because your clients are part of your workflow, everything flows seamlessly. You’re never blocked
              “waiting for clients”. Client Hub is a modern, fresh, all-in-one platform: Workflow, Client Communication,
              Client Portal, File Sharing, Mobile Apps and more.</p> -->

            <!-- 3 -->
            <h3>So what sets Client Hub apart from {{ appName }}?</h3>
            <p>
              Here are nine ways that Client Hub takes {{ appName }} to the next
              level.
            </p>

            <div class="features-items">
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/qbo-integration.svg"
                    class="qbo-icon"
                    alt="Unique QuickBooks Integration"
                  />
                  <h3>Unique QuickBooks Integration</h3>
                  <p>Instantly resolve uncategorized transactions.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/mobile-app.svg"
                    alt="Mobile Apps"
                  />
                  <h3>Mobile Apps</h3>
                  <p>Game-changing for your team and your clients.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/modern-experience.svg"
                    alt="Modern Experience"
                  />
                  <h3>Modern Experience</h3>
                  <p>Staff and clients love our fresh, approachable design.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/client-communication.svg"
                    alt="Client Communication Built-in"
                  />
                  <h3>Client Communication Built-in</h3>
                  <p>So much better than cluttered email inboxes.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/secure-file-sharing.svg"
                    alt="File Sharing Built-in"
                  />
                  <h3>File Sharing Built-in</h3>
                  <p>
                    Internal files and client-facing files, all organized with
                    folders.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/modern-client-portal.svg"
                    alt="Client Portal Built-in"
                  />
                  <h3>Client Portal Built-in</h3>
                  <p>Clients access everything they need right from here.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/innovation.svg"
                    alt="Rapid Innovation"
                  />
                  <h3>Rapid Innovation</h3>
                  <p>
                    Always delighting customers with new capabilities based on
                    your input.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/secure-communication.svg"
                    alt="Secure Communication"
                  />
                  <h3>Secure Communication</h3>
                  <p>Email is just not secure. Don’t risk your firm.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/small-team.svg"
                    alt="Small Team, Personal Service"
                  />
                  <h3>Small Team, Personal Service</h3>
                  <p>You’re working with the founders.</p>
                </div>
              </div>
            </div>

            <div class="video-quote" style="margin: 64px 0">
              <div class="row">
                <div class="col-md-8">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/r9UdUu6aLak"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <p>April Miller, Sand Dollar Bookkeeping</p>
                </div>
                <div class="col-md-4">
                  <h2>
                    Hear about how Sand Dollar Bookkeeping’s client gets them
                    what they need through Client Hub -- and loves doing it!
                  </h2>
                </div>
              </div>
            </div>

            <!-- 4 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>Communicate without the clutter of email boxes</h3>
                  <p class="check-icon">
                    With Client Hub’s conversation panel and mobile apps, your
                    clients and your team communicate everywhere with a
                    delightful experience.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, clients are stuck communicating with you
                    through their cluttered email boxes. And on your side, your
                    business emails can now only be triaged in
                    {{ appName }} (and not in mobile apps).
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/conversations.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 5 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>A client experience that reflects a modern firm</h3>
                  <p class="check-icon">
                    With Client Hub’s modern experience and mobile apps, you
                    stand out for your modern client service.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, your firm is like any other. They
                    suggest Liscio for client experience (more subscription $
                    and more systems for you to maintain).
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/client-experience.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 6 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>No more blocked work that’s “waiting for client”</h3>
                  <p class="check-icon">
                    With Client Hub’s Client Tasks panel available online and in
                    our mobile app, your clients can answer you everywhere with
                    a delightful experience.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, your clients are only notified through
                    their cluttered email boxes and have to click through to
                    their tasks.
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/no-waiting-for-clients.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 7 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>No need for additional apps</h3>
                  <p class="check-icon">
                    With Client Hub, client portal and file sharing is built-in.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, you need additional apps for these key
                    needs.
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/no-additional-apps.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 8 -->
            <h2>We’re simply a more collaborative and complete platform</h2>
            <h3 class="text-center">What we do…</h3>
            <div class="row">
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/client-hub.svg"
                  alt="Client Hub's features Chart"
                />
              </div>
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/{{ app }}.svg"
                  alt="{{ appName }}'s features Chart"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h3 class="text-center" style="margin-bottom: 32px">
                  How We Do It…
                </h3>
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="text-center">Client Hub</h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/ch-experience.svg"
                      alt="Client Hub's Experience"
                    />
                  </div>
                  <div class="col-md-6">
                    <h4 class="text-center">
                      {{ appName }}
                    </h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/{{
                        app
                      }}-experience.svg"
                      alt="{{ appName }}'s Experience"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="section-title text-center" style="margin-top: 80px">
              <h2>Save Big With Client Hub</h2>
              <p>
                Client Hub replaces a bunch of apps. See how our all-in-one
                solution compares to the cost (not to mention complexity) of
                bundling together a comparable “tech stack”.
              </p>
            </div>
            <div class="save-big text-left save-big-wrapper">
              <div class="row">
                <div class="col-md-5">
                  <div class="save-big-box-wrapper">
                    <div class="save-big-box no-plus">
                      <div class="icon">
                        <svg
                          width="41"
                          height="43"
                          viewBox="0 0 41 43"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M39.9505 5.4977C39.1937 1.78237 35.5732 -0.619247 31.8709 0.14024C28.1686 0.899726 25.7753 4.53295 26.5322 8.24827C26.6753 8.98723 26.9822 9.66461 27.3299 10.2804L24.6708 14.3242C23.3617 13.9957 21.9707 13.9136 20.5594 14.201C18.8616 14.55 17.4093 15.371 16.2229 16.4589L12.0501 13.6673C12.2138 12.8873 12.2138 12.0662 12.0501 11.2452C11.3751 7.94037 8.16372 5.8056 4.87049 6.48298C1.57726 7.18089 -0.550043 10.4036 0.124966 13.7084C0.799976 17.0132 4.01139 19.1479 7.30462 18.4706C8.12281 18.3063 8.87964 17.9779 9.51374 17.5263L13.6865 20.2974C13.1547 21.8164 12.9911 23.4996 13.3388 25.1828C13.707 27.0096 14.6274 28.5902 15.8547 29.8218L14.157 32.3876C13.4615 32.2234 12.7456 32.1824 11.9888 32.3261C9.1251 32.9213 7.26371 35.7335 7.83644 38.6277C8.42963 41.5015 11.2319 43.3694 14.1161 42.7947C16.9798 42.1994 18.8411 39.3872 18.2684 36.493C18.1252 35.7335 17.7775 35.0972 17.3479 34.5019L19.0457 31.9361C20.6616 32.5724 22.4617 32.8187 24.2821 32.4287C29.2936 31.4024 32.5459 26.476 31.5027 21.4469C31.2163 20.0306 30.6027 18.7785 29.764 17.6905L32.4232 13.6468C33.1391 13.7289 33.855 13.7289 34.5914 13.5852C38.3142 12.8462 40.7074 9.21303 39.9505 5.4977ZM6.52733 14.6731C5.3205 14.94 4.13411 14.1394 3.88866 12.9284C3.6432 11.7173 4.42048 10.5267 5.62732 10.2804C6.83415 10.0341 8.02053 10.8141 8.26599 12.0252C8.51145 13.2363 7.73417 14.4268 6.52733 14.6731ZM13.5024 39.7772C12.2751 40.0236 11.0888 39.2435 10.8433 38.0119C10.5978 36.7803 11.3751 35.5898 12.6024 35.3435C13.8297 35.0972 15.0161 35.8772 15.2615 37.1088C15.5275 38.3198 14.7297 39.5104 13.5024 39.7772ZM23.3617 27.9128C20.8253 28.426 18.3502 26.7839 17.8389 24.2385C17.3275 21.6932 18.9639 19.2095 21.5003 18.6963C24.0367 18.1832 26.5117 19.8253 27.0231 22.3706C27.5345 24.9159 25.8981 27.3997 23.3617 27.9128ZM33.7323 9.25408C32.4232 9.52093 31.1345 8.67933 30.8686 7.36563C30.6027 6.05192 31.4413 4.75874 32.7504 4.49189C34.0595 4.22505 35.3482 5.06664 35.6141 6.38035C35.88 7.69405 35.0414 8.98723 33.7323 9.25408Z"
                            fill="#0075FF"
                          />
                        </svg>
                      </div>
                      <div class="save-big-text">
                        <h4>Client Hub</h4>
                        <p>$49 - $59/month per user</p>
                      </div>
                    </div>
                    <div class="features">
                      <div class="plan-features">
                        <ul>
                          <li>Simple client messaging</li>
                          <li>Assign and track client tasks</li>
                          <li>QuickBooks categorization tasks</li>
                          <li>Secure client file-sharing</li>
                          <li>Manage Internal files</li>
                          <li>Client apps & resources</li>
                          <li>Mobile app access</li>
                          <li>Your firm branding</li>
                          <li>And much, much more…</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 text-center flex-center">
                  <div class="vs">VS</div>
                </div>
                <div class="col-md-6">
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.2924 0.419922C22.1431 0.419922 22.8319 1.11306 22.8319 1.96891V10.489L29.9988 3.27848C30.6004 2.67357 31.5748 2.67357 32.1766 3.27848C32.7776 3.88354 32.7776 4.86438 32.1766 5.46929L22.8319 14.8707V19.1274L34.7751 7.15781C35.3777 6.55359 36.3525 6.55537 36.9525 7.16179C37.5527 7.76808 37.5509 8.74837 36.9487 9.35247L22.8319 23.5005V28.014L38.0576 12.6953C38.659 12.0908 39.6337 12.0908 40.2351 12.6953C40.8364 13.3008 40.8364 14.2811 40.2351 14.8866L34.1681 20.991L40.2715 27.1319C40.8729 27.7369 40.8729 28.7177 40.2715 29.3226C39.9706 29.625 39.5765 29.7763 39.1829 29.7763C38.7887 29.7763 38.3946 29.625 38.0941 29.3226L31.9901 23.1818L29.5491 25.6381L36.7159 32.8487C37.3168 33.4537 37.3168 34.4344 36.7159 35.0395C36.4151 35.3417 36.0209 35.493 35.6268 35.493C35.233 35.493 34.8389 35.3417 34.538 35.0395L27.3713 27.8289L24.9302 30.2852L31.4921 36.8873C32.0931 37.4922 32.0931 38.473 31.4921 39.0781C31.1913 39.3803 30.7971 39.5317 30.403 39.5317C30.0093 39.5317 29.6152 39.3803 29.3143 39.0781L22.8319 32.5561V40.0309C22.8319 40.8864 22.1431 41.5799 21.2924 41.5799C20.4421 41.5799 19.7526 40.8864 19.7526 40.0309V1.96891C19.7526 1.11306 20.4421 0.419922 21.2924 0.419922V0.419922ZM15.1341 1.30486C15.9844 1.30486 16.6736 1.99841 16.6736 2.85385V39.1454C16.6736 40.001 15.9844 40.6946 15.1341 40.6946C14.2838 40.6946 13.5944 40.001 13.5944 39.1454V2.85385C13.5944 1.99841 14.2838 1.30486 15.1341 1.30486V1.30486ZM8.97549 4.84545C9.82578 4.84545 10.5151 5.53899 10.5151 6.39457V35.6049C10.5151 36.4603 9.82578 37.1539 8.97549 37.1539C8.1252 37.1539 7.43592 36.4603 7.43592 35.6049V6.39457C7.43592 5.53899 8.1252 4.84545 8.97549 4.84545V4.84545ZM2.81692 15.4675C3.66735 15.4675 4.35663 16.161 4.35663 17.0165V24.983C4.35663 25.8384 3.66735 26.532 2.81692 26.532C1.96663 26.532 1.27734 25.8384 1.27734 24.983V17.0165C1.27734 16.161 1.96663 15.4675 2.81692 15.4675Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Karbon (or JetPack/FinancialCents etc.): workflow</h4>
                      <p>$49 - $59/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/liscio.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Liscio: client communication and tasks</h4>
                      <p>$50/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.5 3.1499L21 9.84365L10.5 16.5374L0 9.84365L10.5 3.1499V3.1499ZM31.5 3.1499L42 9.84365L31.5 16.5374L21 9.84365L31.5 3.1499V3.1499ZM0 23.2312L10.5 16.5374L21 23.2312L10.5 29.9249L0 23.2312V23.2312ZM31.5 16.5374L42 23.2312L31.5 29.9249L21 23.2312L31.5 16.5374V16.5374ZM10.5 32.1562L21 25.4624L31.5 32.1562L21 38.8499L10.5 32.1562Z"
                          fill="#3A4D97"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Dropbox for Teams (or Sharefile etc.): files</h4>
                      <p>$15/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg no-plus">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/uncat.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Uncat: QuickBooks uncategorized automation</h4>
                      <p>$5/month per client</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 9 -->
            <h2 class="text-center">We’ll help you evaluate and switch</h2>
            <p class="text-center">
              Get all your questions answered. Schedule a 1/1 demo
              <a (click)="openModal(demoScheduleModal)" target="_blank" rel="noreferrer noopener">here</a
              >.
            </p>

            <div class="row fix-mobile">
              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      SO THANKFUL<br />
                      <p style="font-weight: normal">CortnieG</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    The app is new, but they seem totally interested in making
                    it better and better! I have not even been a client a year
                    and I have had such a great experience overall!!!! I am
                    happy to call myself an excited and HAPPY customer and in
                    turn made a great experience for my firm. I highly recommend
                    it and would be willing to help anyone out if they had any
                    questions!! I cant wait to see what this product becomes!!
                    It is getting better and better as we go!!!!!!! (AND MY
                    CLEINTS LOVE IT TOO!)
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      EXACTLY what my firm needed<br />
                      <p style="font-weight: normal">eControllerPlus</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I am blown away by this app! Everything at my fingertips and
                    everything at my clients' fingertips as well! I have moved
                    ALL client communications here and it couldn't be easier to
                    navigate our conversations. The ability to share docs with
                    clients and staff OR staff ONLY is brilliant. Wish I had
                    integrated this earlier!!
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      THE best acct practice software on the market
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I've been struggling for years to find the right combination
                    of software that would allow me and my team to manage all of
                    our bookkeeping clients from one location. The QuickBooks
                    team area works great for QuickBooks clients, but for all my
                    desktop/other accounting application clients, it just didn't
                    cut it. Client Hub does. With chat, file storage, QuickBooks
                    integration, and task lists as features, this has everything
                    I need to provide a full-service bookkeeping experience for
                    all my clients. Client Hub also allows you to "bookmark"
                    client-specific links - like to their banking applications,
                    third party software, and firm-developed applications.
                    Absolutely fantastic.
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center" style="margin-top: 30px">
              <div class="reviews-app row d-flex align-items-center">
                <div class="col-md-6 text-right">
                  <a
                    href="https://quickbooks.intuit.com/app/apps/appdetails/ClientHub/en-us//"
                    target="_blank" rel="noreferrer noopener"
                    class="btn btn-success"
                    >See all our app reviews</a
                  >
                </div>
                <div class="col-md-6 text-left">No Reviews Filtered Out</div>
              </div>
            </div>

            <!-- 10 -->
            <div class="big-cta orange">
              <div class="row">
                <div class="col-sm-3 col-md-3 cta-illustration">
                  <img
                    src="assets/img/landing-page-v4/billy-cta-2.png"
                    alt="Image of an accountant"
                  />
                </div>
                <div class="col-sm-5 col-md-6">
                  <div class="title">No More Waiting for Clients!</div>
                </div>
                <div class="col-sm-3 col-md-3 text-right">
                  <button class="btn btn-orange" (click)="startRegistration()">
                    Start Trial
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- JetPack -->

          <div *ngIf="app == 'clickup' || app == 'asana'">
            <!-- 1 -->
            <h1 style="margin-top: 0">
              Why choose Client Hub over {{ appName }}
            </h1>
            <h3 style="margin-top: 0">
              If you’re looking to understand the difference between
              {{ appName }} and Client Hub, you’re in the right place.
            </h3>
            <p>
              First, we’d like to acknowledge the team at {{ appName }}. They
              have developed a very good workflow system to help accounting and
              bookkeeping firms.
            </p>
            <p>
              Client Hub is a workflow system
              <strong>with Client Collaboration built-in</strong>, which goes
              beyond just tracking your work and deadlines. With Client Hub’s
              amazing client experience and mobile app, you always have what you
              need from clients to get your work done.
            </p>
            <p>
              And for your clients on QuickBooks Online, our powerful QuickBooks
              integration automates resolving uncategorized transactions, saving
              your team hours of time.
            </p>
            <p>
              In short, by including clients and client experience in your
              workflow system, we take {{ appName }} to the next level.
            </p>

            <!-- 2 -->
            <!-- <h2>{{ appName }} tries to serve all kinds of businesses.
              <br>We’re built just for accountants and bookkeepers.
            </h2>
            <p>{{ appName }} is a mile wide and solving for all kinds of needs across all kinds of businesses. When you
              use {{ appName }}, you won’t even see the word “client” anywhere in the platform: you’ll always be trying
              to translate their terminology (spaces, lists, tasks) into your world.
            </p>
            <p>We’re built just for accountants and bookkeepers. We reimagined your firm’s work in an approachable,
              client-centric way -- on a workflow system that is designed from the ground up for both your internal team
              and your clients.</p>
            <p>Because your clients are part of your workflow, everything flows seamlessly. You’re never blocked
              “waiting for clients”. Client Hub is a modern, fresh, all-in-one platform: Workflow, Client Communication,
              Client Portal, File Sharing, Mobile Apps and more.</p> -->

            <!-- 3 -->
            <h3>So what sets Client Hub apart from {{ appName }}?</h3>
            <p>
              Here are nine ways that Client Hub takes {{ appName }} to the next
              level.
            </p>

            <div class="features-items">
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/qbo-integration.svg"
                    class="qbo-icon"
                    alt="Unique QuickBooks Integration"
                  />
                  <h3>Unique QuickBooks Integration</h3>
                  <p>Instantly resolve uncategorized transactions.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/mobile-app.svg"
                    alt="Mobile Apps"
                  />
                  <h3>Mobile Apps</h3>
                  <p>Game-changing for your team and your clients.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/modern-experience.svg"
                    alt="Modern Experience"
                  />
                  <h3>Modern Experience</h3>
                  <p>Staff and clients love our fresh, approachable design.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/client-communication.svg"
                    alt="Client Communication Built-in"
                  />
                  <h3>Client Communication Built-in</h3>
                  <p>So much better than cluttered email inboxes.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/secure-file-sharing.svg"
                    alt="File Sharing Built-in"
                  />
                  <h3>File Sharing Built-in</h3>
                  <p>
                    Internal files and client-facing files, all organized with
                    folders.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/modern-client-portal.svg"
                    alt="Client Portal Built-in"
                  />
                  <h3>Client Portal Built-in</h3>
                  <p>Clients access everything they need right from here.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/innovation.svg"
                    alt="Rapid Innovation"
                  />
                  <h3>Rapid Innovation</h3>
                  <p>
                    Always delighting customers with new capabilities based on
                    your input.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/secure-communication.svg"
                    alt="Secure Communication"
                  />
                  <h3>Secure Communication</h3>
                  <p>Email is just not secure. Don’t risk your firm.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/small-team.svg"
                    alt="Small Team, Personal Service"
                  />
                  <h3>Small Team, Personal Service</h3>
                  <p>You’re working with the founders.</p>
                </div>
              </div>
            </div>

            <div class="video-quote" style="margin: 64px 0">
              <div class="row">
                <div class="col-md-8">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/r9UdUu6aLak"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <p>April Miller, Sand Dollar Bookkeeping</p>
                </div>
                <div class="col-md-4">
                  <h2>
                    Hear about how Sand Dollar Bookkeeping’s client gets them
                    what they need through Client Hub -- and loves doing it!
                  </h2>
                </div>
              </div>
            </div>

            <!-- 4 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>Communicate without the clutter of email boxes</h3>
                  <p class="check-icon">
                    With Client Hub’s conversation panel and mobile apps, your
                    clients and your team communicate everywhere with a
                    delightful experience.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, clients are stuck communicating with you
                    through their cluttered email boxes. And on your side, your
                    business emails can now only be triaged in
                    {{ appName }} (and not in mobile apps).
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/conversations.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 5 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>A client experience that reflects a modern firm</h3>
                  <p class="check-icon">
                    With Client Hub’s modern experience and mobile apps, you
                    stand out for your modern client service.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, your firm is like any other. They
                    suggest Liscio for client experience (more subscription $
                    and more systems for you to maintain).
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/client-experience.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 6 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>No more blocked work that’s “waiting for client”</h3>
                  <p class="check-icon">
                    With Client Hub’s Client Tasks panel available online and in
                    our mobile app, your clients can answer you everywhere with
                    a delightful experience.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, your clients are only notified through
                    their cluttered email boxes and have to click through to
                    their tasks.
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/no-waiting-for-clients.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 7 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>No need for additional apps</h3>
                  <p class="check-icon">
                    With Client Hub, client portal and file sharing is built-in.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, you need additional apps for these key
                    needs.
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/no-additional-apps.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 8 -->
            <h2>We’re simply a more collaborative and complete platform</h2>
            <h3 class="text-center">What we do…</h3>
            <div class="row">
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/client-hub.svg"
                  alt="Client Hub's features Chart"
                />
              </div>
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/{{ app }}.svg"
                  alt="{{ appName }}'s features Chart"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h3 class="text-center" style="margin-bottom: 32px">
                  How We Do It…
                </h3>
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="text-center">Client Hub</h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/ch-experience.svg"
                      alt="Client Hub's Experience"
                    />
                  </div>
                  <div class="col-md-6">
                    <h4 class="text-center">
                      {{ appName }}
                    </h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/{{
                        app
                      }}-experience.svg"
                      alt="{{ appName }}'s Experience"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="section-title text-center" style="margin-top: 80px">
              <h2>Save Big With Client Hub</h2>
              <p>
                Client Hub replaces a bunch of apps. See how our all-in-one
                solution compares to the cost (not to mention complexity) of
                bundling together a comparable “tech stack”.
              </p>
            </div>
            <div class="save-big text-left save-big-wrapper">
              <div class="row">
                <div class="col-md-5">
                  <div class="save-big-box-wrapper">
                    <div class="save-big-box no-plus">
                      <div class="icon">
                        <svg
                          width="41"
                          height="43"
                          viewBox="0 0 41 43"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M39.9505 5.4977C39.1937 1.78237 35.5732 -0.619247 31.8709 0.14024C28.1686 0.899726 25.7753 4.53295 26.5322 8.24827C26.6753 8.98723 26.9822 9.66461 27.3299 10.2804L24.6708 14.3242C23.3617 13.9957 21.9707 13.9136 20.5594 14.201C18.8616 14.55 17.4093 15.371 16.2229 16.4589L12.0501 13.6673C12.2138 12.8873 12.2138 12.0662 12.0501 11.2452C11.3751 7.94037 8.16372 5.8056 4.87049 6.48298C1.57726 7.18089 -0.550043 10.4036 0.124966 13.7084C0.799976 17.0132 4.01139 19.1479 7.30462 18.4706C8.12281 18.3063 8.87964 17.9779 9.51374 17.5263L13.6865 20.2974C13.1547 21.8164 12.9911 23.4996 13.3388 25.1828C13.707 27.0096 14.6274 28.5902 15.8547 29.8218L14.157 32.3876C13.4615 32.2234 12.7456 32.1824 11.9888 32.3261C9.1251 32.9213 7.26371 35.7335 7.83644 38.6277C8.42963 41.5015 11.2319 43.3694 14.1161 42.7947C16.9798 42.1994 18.8411 39.3872 18.2684 36.493C18.1252 35.7335 17.7775 35.0972 17.3479 34.5019L19.0457 31.9361C20.6616 32.5724 22.4617 32.8187 24.2821 32.4287C29.2936 31.4024 32.5459 26.476 31.5027 21.4469C31.2163 20.0306 30.6027 18.7785 29.764 17.6905L32.4232 13.6468C33.1391 13.7289 33.855 13.7289 34.5914 13.5852C38.3142 12.8462 40.7074 9.21303 39.9505 5.4977ZM6.52733 14.6731C5.3205 14.94 4.13411 14.1394 3.88866 12.9284C3.6432 11.7173 4.42048 10.5267 5.62732 10.2804C6.83415 10.0341 8.02053 10.8141 8.26599 12.0252C8.51145 13.2363 7.73417 14.4268 6.52733 14.6731ZM13.5024 39.7772C12.2751 40.0236 11.0888 39.2435 10.8433 38.0119C10.5978 36.7803 11.3751 35.5898 12.6024 35.3435C13.8297 35.0972 15.0161 35.8772 15.2615 37.1088C15.5275 38.3198 14.7297 39.5104 13.5024 39.7772ZM23.3617 27.9128C20.8253 28.426 18.3502 26.7839 17.8389 24.2385C17.3275 21.6932 18.9639 19.2095 21.5003 18.6963C24.0367 18.1832 26.5117 19.8253 27.0231 22.3706C27.5345 24.9159 25.8981 27.3997 23.3617 27.9128ZM33.7323 9.25408C32.4232 9.52093 31.1345 8.67933 30.8686 7.36563C30.6027 6.05192 31.4413 4.75874 32.7504 4.49189C34.0595 4.22505 35.3482 5.06664 35.6141 6.38035C35.88 7.69405 35.0414 8.98723 33.7323 9.25408Z"
                            fill="#0075FF"
                          />
                        </svg>
                      </div>
                      <div class="save-big-text">
                        <h4>Client Hub</h4>
                        <p>$49 - $59/month per user</p>
                      </div>
                    </div>
                    <div class="features">
                      <div class="plan-features">
                        <ul>
                          <li>Simple client messaging</li>
                          <li>Assign and track client tasks</li>
                          <li>QuickBooks categorization tasks</li>
                          <li>Secure client file-sharing</li>
                          <li>Manage Internal files</li>
                          <li>Client apps & resources</li>
                          <li>Mobile app access</li>
                          <li>Your firm branding</li>
                          <li>And much, much more…</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 text-center flex-center">
                  <div class="vs">VS</div>
                </div>
                <div class="col-md-6">
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.2924 0.419922C22.1431 0.419922 22.8319 1.11306 22.8319 1.96891V10.489L29.9988 3.27848C30.6004 2.67357 31.5748 2.67357 32.1766 3.27848C32.7776 3.88354 32.7776 4.86438 32.1766 5.46929L22.8319 14.8707V19.1274L34.7751 7.15781C35.3777 6.55359 36.3525 6.55537 36.9525 7.16179C37.5527 7.76808 37.5509 8.74837 36.9487 9.35247L22.8319 23.5005V28.014L38.0576 12.6953C38.659 12.0908 39.6337 12.0908 40.2351 12.6953C40.8364 13.3008 40.8364 14.2811 40.2351 14.8866L34.1681 20.991L40.2715 27.1319C40.8729 27.7369 40.8729 28.7177 40.2715 29.3226C39.9706 29.625 39.5765 29.7763 39.1829 29.7763C38.7887 29.7763 38.3946 29.625 38.0941 29.3226L31.9901 23.1818L29.5491 25.6381L36.7159 32.8487C37.3168 33.4537 37.3168 34.4344 36.7159 35.0395C36.4151 35.3417 36.0209 35.493 35.6268 35.493C35.233 35.493 34.8389 35.3417 34.538 35.0395L27.3713 27.8289L24.9302 30.2852L31.4921 36.8873C32.0931 37.4922 32.0931 38.473 31.4921 39.0781C31.1913 39.3803 30.7971 39.5317 30.403 39.5317C30.0093 39.5317 29.6152 39.3803 29.3143 39.0781L22.8319 32.5561V40.0309C22.8319 40.8864 22.1431 41.5799 21.2924 41.5799C20.4421 41.5799 19.7526 40.8864 19.7526 40.0309V1.96891C19.7526 1.11306 20.4421 0.419922 21.2924 0.419922V0.419922ZM15.1341 1.30486C15.9844 1.30486 16.6736 1.99841 16.6736 2.85385V39.1454C16.6736 40.001 15.9844 40.6946 15.1341 40.6946C14.2838 40.6946 13.5944 40.001 13.5944 39.1454V2.85385C13.5944 1.99841 14.2838 1.30486 15.1341 1.30486V1.30486ZM8.97549 4.84545C9.82578 4.84545 10.5151 5.53899 10.5151 6.39457V35.6049C10.5151 36.4603 9.82578 37.1539 8.97549 37.1539C8.1252 37.1539 7.43592 36.4603 7.43592 35.6049V6.39457C7.43592 5.53899 8.1252 4.84545 8.97549 4.84545V4.84545ZM2.81692 15.4675C3.66735 15.4675 4.35663 16.161 4.35663 17.0165V24.983C4.35663 25.8384 3.66735 26.532 2.81692 26.532C1.96663 26.532 1.27734 25.8384 1.27734 24.983V17.0165C1.27734 16.161 1.96663 15.4675 2.81692 15.4675Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Karbon (or JetPack/FinancialCents etc.): workflow</h4>
                      <p>$49 - $59/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/liscio.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Liscio: client communication and tasks</h4>
                      <p>$50/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.5 3.1499L21 9.84365L10.5 16.5374L0 9.84365L10.5 3.1499V3.1499ZM31.5 3.1499L42 9.84365L31.5 16.5374L21 9.84365L31.5 3.1499V3.1499ZM0 23.2312L10.5 16.5374L21 23.2312L10.5 29.9249L0 23.2312V23.2312ZM31.5 16.5374L42 23.2312L31.5 29.9249L21 23.2312L31.5 16.5374V16.5374ZM10.5 32.1562L21 25.4624L31.5 32.1562L21 38.8499L10.5 32.1562Z"
                          fill="#3A4D97"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Dropbox for Teams (or Sharefile etc.): files</h4>
                      <p>$15/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg no-plus">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/uncat.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Uncat: QuickBooks uncategorized automation</h4>
                      <p>$5/month per client</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 9 -->
            <h2 class="text-center">We’ll help you evaluate and switch</h2>
            <p class="text-center">
              Get all your questions answered. Schedule a 1/1 demo
              <a (click)="openModal(demoScheduleModal)" target="_blank" rel="noreferrer noopener">here</a
              >.
            </p>

            <div class="row fix-mobile">
              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      SO THANKFUL<br />
                      <p style="font-weight: normal">CortnieG</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    The app is new, but they seem totally interested in making
                    it better and better! I have not even been a client a year
                    and I have had such a great experience overall!!!! I am
                    happy to call myself an excited and HAPPY customer and in
                    turn made a great experience for my firm. I highly recommend
                    it and would be willing to help anyone out if they had any
                    questions!! I cant wait to see what this product becomes!!
                    It is getting better and better as we go!!!!!!! (AND MY
                    CLEINTS LOVE IT TOO!)
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      EXACTLY what my firm needed<br />
                      <p style="font-weight: normal">eControllerPlus</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I am blown away by this app! Everything at my fingertips and
                    everything at my clients' fingertips as well! I have moved
                    ALL client communications here and it couldn't be easier to
                    navigate our conversations. The ability to share docs with
                    clients and staff OR staff ONLY is brilliant. Wish I had
                    integrated this earlier!!
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      THE best acct practice software on the market
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I've been struggling for years to find the right combination
                    of software that would allow me and my team to manage all of
                    our bookkeeping clients from one location. The QuickBooks
                    team area works great for QuickBooks clients, but for all my
                    desktop/other accounting application clients, it just didn't
                    cut it. Client Hub does. With chat, file storage, QuickBooks
                    integration, and task lists as features, this has everything
                    I need to provide a full-service bookkeeping experience for
                    all my clients. Client Hub also allows you to "bookmark"
                    client-specific links - like to their banking applications,
                    third party software, and firm-developed applications.
                    Absolutely fantastic.
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center" style="margin-top: 30px">
              <div class="reviews-app row d-flex align-items-center">
                <div class="col-md-6 text-right">
                  <a
                    href="https://quickbooks.intuit.com/app/apps/appdetails/ClientHub/en-us//"
                    target="_blank" rel="noreferrer noopener"
                    class="btn btn-success"
                    >See all our app reviews</a
                  >
                </div>
                <div class="col-md-6 text-left">No Reviews Filtered Out</div>
              </div>
            </div>

            <!-- 10 -->
            <div class="big-cta orange">
              <div class="row">
                <div class="col-sm-3 col-md-3 cta-illustration">
                  <img
                    src="assets/img/landing-page-v4/billy-cta-2.png"
                    alt="Image of an accountant"
                  />
                </div>
                <div class="col-sm-5 col-md-6">
                  <div class="title">No More Waiting for Clients!</div>
                </div>
                <div class="col-sm-3 col-md-3 text-right">
                  <button class="btn btn-orange" (click)="startRegistration()">
                    Start Trial
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- ClickUp / Asana -->

          <div *ngIf="app == 'financial-cents'">
            <!-- 1 -->
            <h1 style="margin-top: 0">
              Why choose Client Hub over {{ appName }}
            </h1>
            <h3 style="margin-top: 0">
              If you’re looking to understand the difference between Financial
              Cents and Client Hub, you’re in the right place.
            </h3>
            <p>
              First, we’d like to acknowledge the team at Financial Cents. They
              have developed a very good workflow system to help accounting and
              bookkeeping firms.
            </p>
            <p>
              Client Hub is a workflow system
              <strong>with Client Collaboration built-in</strong>, which goes
              beyond just tracking your work and deadlines. With Client Hub’s
              amazing client experience and mobile app, you always have what you
              need from clients to get your work done.
            </p>
            <p>
              And for your clients on QuickBooks Online, our powerful QuickBooks
              integration automates resolving uncategorized transactions, saving
              your team hours of time.
            </p>
            <p>
              In short, by including clients and client experience in your
              workflow system, we take Financial Cents to the next level.
            </p>

            <!-- 2 -->
            <!-- <h2>{{ appName }} is for internal teams.
              <br>We deliver workflow across your team and your clients.
            </h2>
            <p>{{ appName }} has been getting attention recently from accounting professionals. It remains focused only
              on managing deadlines and assignments.
            </p>
            <p>We’re reimaging your firm’s work in an approachable, client-centric way -- on a workflow system that is
              designed from the ground up for both your internal team and your clients.</p>
            <p>Because your clients are part of your workflow, everything flows seamlessly. You’re never blocked
              “waiting for clients”. Client Hub is a modern, fresh, all-in-one platform: Workflow, Client Communication,
              Client Portal, File Sharing, Mobile Apps and more.</p> -->

            <!-- 3 -->
            <h3>So what sets Client Hub apart from {{ appName }}?</h3>
            <p>
              Here are nine ways that Client Hub takes {{ appName }} to the next
              level.
            </p>

            <div class="features-items">
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/qbo-integration.svg"
                    class="qbo-icon"
                    alt="Unique QuickBooks Integration"
                  />
                  <h3>Unique QuickBooks Integration</h3>
                  <p>Instantly resolve uncategorized transactions.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/mobile-app.svg"
                    alt="Mobile Apps"
                  />
                  <h3>Mobile Apps</h3>
                  <p>Game-changing for your team and your clients.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/modern-experience.svg"
                    alt="Modern Experience"
                  />
                  <h3>Modern Experience</h3>
                  <p>Staff and clients love our fresh, approachable design.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/client-communication.svg"
                    alt="Client Communication Built-in"
                  />
                  <h3>Client Communication Built-in</h3>
                  <p>So much better than cluttered email inboxes.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/secure-file-sharing.svg"
                    alt="File Sharing Built-in"
                  />
                  <h3>File Sharing Built-in</h3>
                  <p>
                    Internal files and client-facing files, all organized with
                    folders.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/modern-client-portal.svg"
                    alt="Client Portal Built-in"
                  />
                  <h3>Client Portal Built-in</h3>
                  <p>Clients access everything they need right from here.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/innovation.svg"
                    alt="Rapid Innovation"
                  />
                  <h3>Rapid Innovation</h3>
                  <p>
                    Always delighting customers with new capabilities based on
                    your input.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/secure-communication.svg"
                    alt="Secure Communication"
                  />
                  <h3>Secure Communication</h3>
                  <p>Email is just not secure. Don’t risk your firm.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/small-team.svg"
                    alt="Small Team, Personal Service"
                  />
                  <h3>Small Team, Personal Service</h3>
                  <p>You’re working with the founders.</p>
                </div>
              </div>
            </div>

            <div class="video-quote" style="margin: 64px 0">
              <div class="row">
                <div class="col-md-8">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/r9UdUu6aLak"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <p>April Miller, Sand Dollar Bookkeeping</p>
                </div>
                <div class="col-md-4">
                  <h2>
                    Hear about how Sand Dollar Bookkeeping’s client gets them
                    what they need through Client Hub -- and loves doing it!
                  </h2>
                </div>
              </div>
            </div>

            <!-- 4 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>Communicate without the clutter of email boxes</h3>
                  <p class="check-icon">
                    With Client Hub’s conversation panel and mobile apps, your
                    clients and your team communicate everywhere with a
                    delightful experience.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, clients are stuck communicating with you
                    through their cluttered email boxes. And on your side, your
                    business emails can now only be triaged in
                    {{ appName }} (and not in mobile apps).
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/conversations.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 5 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>A client experience that reflects a modern firm</h3>
                  <p class="check-icon">
                    With Client Hub’s modern experience and mobile apps, you
                    stand out for your modern client service.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, your firm is like any other. They
                    suggest Liscio for client experience (more subscription $
                    and more systems for you to maintain).
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/client-experience.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 6 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>No more blocked work that’s “waiting for client”</h3>
                  <p class="check-icon">
                    With Client Hub’s Client Tasks panel available online and in
                    our mobile app, your clients can answer you everywhere with
                    a delightful experience.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, your clients are only notified through
                    their cluttered email boxes and have to click through to
                    their tasks.
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/no-waiting-for-clients.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 7 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>No need for additional apps</h3>
                  <p class="check-icon">
                    With Client Hub, client portal and file sharing is built-in.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, you need additional apps for these key
                    needs.
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/no-additional-apps.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 8 -->
            <h2>We’re simply a more collaborative and complete platform</h2>
            <h3 class="text-center">What we do…</h3>
            <div class="row">
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/client-hub.svg"
                  alt="Client Hub's features Chart"
                />
              </div>
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/{{ app }}.svg"
                  alt="{{ appName }}'s features Chart"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h3 class="text-center" style="margin-bottom: 32px">
                  How We Do It…
                </h3>
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="text-center">Client Hub</h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/ch-experience.svg"
                      alt="Client Hub's Experience"
                    />
                  </div>
                  <div class="col-md-6">
                    <h4 class="text-center">
                      {{ appName }}
                    </h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/{{
                        app
                      }}-experience.svg"
                      alt="{{ appName }}'s Experience"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="section-title text-center" style="margin-top: 80px">
              <h2>Save Big With Client Hub</h2>
              <p>
                Client Hub replaces a bunch of apps. See how our all-in-one
                solution compares to the cost (not to mention complexity) of
                bundling together a comparable “tech stack”.
              </p>
            </div>
            <div class="save-big text-left save-big-wrapper">
              <div class="row">
                <div class="col-md-5">
                  <div class="save-big-box-wrapper">
                    <div class="save-big-box no-plus">
                      <div class="icon">
                        <svg
                          width="41"
                          height="43"
                          viewBox="0 0 41 43"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M39.9505 5.4977C39.1937 1.78237 35.5732 -0.619247 31.8709 0.14024C28.1686 0.899726 25.7753 4.53295 26.5322 8.24827C26.6753 8.98723 26.9822 9.66461 27.3299 10.2804L24.6708 14.3242C23.3617 13.9957 21.9707 13.9136 20.5594 14.201C18.8616 14.55 17.4093 15.371 16.2229 16.4589L12.0501 13.6673C12.2138 12.8873 12.2138 12.0662 12.0501 11.2452C11.3751 7.94037 8.16372 5.8056 4.87049 6.48298C1.57726 7.18089 -0.550043 10.4036 0.124966 13.7084C0.799976 17.0132 4.01139 19.1479 7.30462 18.4706C8.12281 18.3063 8.87964 17.9779 9.51374 17.5263L13.6865 20.2974C13.1547 21.8164 12.9911 23.4996 13.3388 25.1828C13.707 27.0096 14.6274 28.5902 15.8547 29.8218L14.157 32.3876C13.4615 32.2234 12.7456 32.1824 11.9888 32.3261C9.1251 32.9213 7.26371 35.7335 7.83644 38.6277C8.42963 41.5015 11.2319 43.3694 14.1161 42.7947C16.9798 42.1994 18.8411 39.3872 18.2684 36.493C18.1252 35.7335 17.7775 35.0972 17.3479 34.5019L19.0457 31.9361C20.6616 32.5724 22.4617 32.8187 24.2821 32.4287C29.2936 31.4024 32.5459 26.476 31.5027 21.4469C31.2163 20.0306 30.6027 18.7785 29.764 17.6905L32.4232 13.6468C33.1391 13.7289 33.855 13.7289 34.5914 13.5852C38.3142 12.8462 40.7074 9.21303 39.9505 5.4977ZM6.52733 14.6731C5.3205 14.94 4.13411 14.1394 3.88866 12.9284C3.6432 11.7173 4.42048 10.5267 5.62732 10.2804C6.83415 10.0341 8.02053 10.8141 8.26599 12.0252C8.51145 13.2363 7.73417 14.4268 6.52733 14.6731ZM13.5024 39.7772C12.2751 40.0236 11.0888 39.2435 10.8433 38.0119C10.5978 36.7803 11.3751 35.5898 12.6024 35.3435C13.8297 35.0972 15.0161 35.8772 15.2615 37.1088C15.5275 38.3198 14.7297 39.5104 13.5024 39.7772ZM23.3617 27.9128C20.8253 28.426 18.3502 26.7839 17.8389 24.2385C17.3275 21.6932 18.9639 19.2095 21.5003 18.6963C24.0367 18.1832 26.5117 19.8253 27.0231 22.3706C27.5345 24.9159 25.8981 27.3997 23.3617 27.9128ZM33.7323 9.25408C32.4232 9.52093 31.1345 8.67933 30.8686 7.36563C30.6027 6.05192 31.4413 4.75874 32.7504 4.49189C34.0595 4.22505 35.3482 5.06664 35.6141 6.38035C35.88 7.69405 35.0414 8.98723 33.7323 9.25408Z"
                            fill="#0075FF"
                          />
                        </svg>
                      </div>
                      <div class="save-big-text">
                        <h4>Client Hub</h4>
                        <p>$49 - $59/month per user</p>
                      </div>
                    </div>
                    <div class="features">
                      <div class="plan-features">
                        <ul>
                          <li>Simple client messaging</li>
                          <li>Assign and track client tasks</li>
                          <li>QuickBooks categorization tasks</li>
                          <li>Secure client file-sharing</li>
                          <li>Manage Internal files</li>
                          <li>Client apps & resources</li>
                          <li>Mobile app access</li>
                          <li>Your firm branding</li>
                          <li>And much, much more…</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 text-center flex-center">
                  <div class="vs">VS</div>
                </div>
                <div class="col-md-6">
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.2924 0.419922C22.1431 0.419922 22.8319 1.11306 22.8319 1.96891V10.489L29.9988 3.27848C30.6004 2.67357 31.5748 2.67357 32.1766 3.27848C32.7776 3.88354 32.7776 4.86438 32.1766 5.46929L22.8319 14.8707V19.1274L34.7751 7.15781C35.3777 6.55359 36.3525 6.55537 36.9525 7.16179C37.5527 7.76808 37.5509 8.74837 36.9487 9.35247L22.8319 23.5005V28.014L38.0576 12.6953C38.659 12.0908 39.6337 12.0908 40.2351 12.6953C40.8364 13.3008 40.8364 14.2811 40.2351 14.8866L34.1681 20.991L40.2715 27.1319C40.8729 27.7369 40.8729 28.7177 40.2715 29.3226C39.9706 29.625 39.5765 29.7763 39.1829 29.7763C38.7887 29.7763 38.3946 29.625 38.0941 29.3226L31.9901 23.1818L29.5491 25.6381L36.7159 32.8487C37.3168 33.4537 37.3168 34.4344 36.7159 35.0395C36.4151 35.3417 36.0209 35.493 35.6268 35.493C35.233 35.493 34.8389 35.3417 34.538 35.0395L27.3713 27.8289L24.9302 30.2852L31.4921 36.8873C32.0931 37.4922 32.0931 38.473 31.4921 39.0781C31.1913 39.3803 30.7971 39.5317 30.403 39.5317C30.0093 39.5317 29.6152 39.3803 29.3143 39.0781L22.8319 32.5561V40.0309C22.8319 40.8864 22.1431 41.5799 21.2924 41.5799C20.4421 41.5799 19.7526 40.8864 19.7526 40.0309V1.96891C19.7526 1.11306 20.4421 0.419922 21.2924 0.419922V0.419922ZM15.1341 1.30486C15.9844 1.30486 16.6736 1.99841 16.6736 2.85385V39.1454C16.6736 40.001 15.9844 40.6946 15.1341 40.6946C14.2838 40.6946 13.5944 40.001 13.5944 39.1454V2.85385C13.5944 1.99841 14.2838 1.30486 15.1341 1.30486V1.30486ZM8.97549 4.84545C9.82578 4.84545 10.5151 5.53899 10.5151 6.39457V35.6049C10.5151 36.4603 9.82578 37.1539 8.97549 37.1539C8.1252 37.1539 7.43592 36.4603 7.43592 35.6049V6.39457C7.43592 5.53899 8.1252 4.84545 8.97549 4.84545V4.84545ZM2.81692 15.4675C3.66735 15.4675 4.35663 16.161 4.35663 17.0165V24.983C4.35663 25.8384 3.66735 26.532 2.81692 26.532C1.96663 26.532 1.27734 25.8384 1.27734 24.983V17.0165C1.27734 16.161 1.96663 15.4675 2.81692 15.4675Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Karbon (or JetPack/FinancialCents etc.): workflow</h4>
                      <p>$49 - $59/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/liscio.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Liscio: client communication and tasks</h4>
                      <p>$50/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.5 3.1499L21 9.84365L10.5 16.5374L0 9.84365L10.5 3.1499V3.1499ZM31.5 3.1499L42 9.84365L31.5 16.5374L21 9.84365L31.5 3.1499V3.1499ZM0 23.2312L10.5 16.5374L21 23.2312L10.5 29.9249L0 23.2312V23.2312ZM31.5 16.5374L42 23.2312L31.5 29.9249L21 23.2312L31.5 16.5374V16.5374ZM10.5 32.1562L21 25.4624L31.5 32.1562L21 38.8499L10.5 32.1562Z"
                          fill="#3A4D97"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Dropbox for Teams (or Sharefile etc.): files</h4>
                      <p>$15/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg no-plus">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/uncat.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Uncat: QuickBooks uncategorized automation</h4>
                      <p>$5/month per client</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 9 -->
            <h2 class="text-center">We’ll help you evaluate and switch</h2>
            <p class="text-center">
              Get all your questions answered. Schedule a 1/1 demo
              <a (click)="openModal(demoScheduleModal)" target="_blank" rel="noreferrer noopener">here</a
              >.
            </p>

            <div class="row fix-mobile">
              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      SO THANKFUL<br />
                      <p style="font-weight: normal">CortnieG</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    The app is new, but they seem totally interested in making
                    it better and better! I have not even been a client a year
                    and I have had such a great experience overall!!!! I am
                    happy to call myself an excited and HAPPY customer and in
                    turn made a great experience for my firm. I highly recommend
                    it and would be willing to help anyone out if they had any
                    questions!! I cant wait to see what this product becomes!!
                    It is getting better and better as we go!!!!!!! (AND MY
                    CLEINTS LOVE IT TOO!)
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      EXACTLY what my firm needed<br />
                      <p style="font-weight: normal">eControllerPlus</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I am blown away by this app! Everything at my fingertips and
                    everything at my clients' fingertips as well! I have moved
                    ALL client communications here and it couldn't be easier to
                    navigate our conversations. The ability to share docs with
                    clients and staff OR staff ONLY is brilliant. Wish I had
                    integrated this earlier!!
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      THE best acct practice software on the market
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I've been struggling for years to find the right combination
                    of software that would allow me and my team to manage all of
                    our bookkeeping clients from one location. The QuickBooks
                    team area works great for QuickBooks clients, but for all my
                    desktop/other accounting application clients, it just didn't
                    cut it. Client Hub does. With chat, file storage, QuickBooks
                    integration, and task lists as features, this has everything
                    I need to provide a full-service bookkeeping experience for
                    all my clients. Client Hub also allows you to "bookmark"
                    client-specific links - like to their banking applications,
                    third party software, and firm-developed applications.
                    Absolutely fantastic.
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center" style="margin-top: 30px">
              <div class="reviews-app row d-flex align-items-center">
                <div class="col-md-6 text-right">
                  <a
                    href="https://quickbooks.intuit.com/app/apps/appdetails/ClientHub/en-us//"
                    target="_blank" rel="noreferrer noopener"
                    class="btn btn-success"
                    >See all our app reviews</a
                  >
                </div>
                <div class="col-md-6 text-left">No Reviews Filtered Out</div>
              </div>
            </div>

            <!-- 10 -->
            <div class="big-cta orange">
              <div class="row">
                <div class="col-sm-3 col-md-3 cta-illustration">
                  <img
                    src="assets/img/landing-page-v4/billy-cta-2.png"
                    alt="Image of an accountant"
                  />
                </div>
                <div class="col-sm-5 col-md-6">
                  <div class="title">No More Waiting for Clients!</div>
                </div>
                <div class="col-sm-3 col-md-3 text-right">
                  <button class="btn btn-orange" (click)="startRegistration()">
                    Start Trial
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Financial Cents -->

          <div *ngIf="app == 'liscio'">
            <!-- 1 -->
            <h1 style="margin-top: 0">
              Why choose Client Hub over {{ appName }}
            </h1>
            <h3 style="margin-top: 0">
              If you’re looking to understand the difference between Liscio and
              Client Hub, you’re in the right place.
            </h3>
            <p>
              First, we’d like to acknowledge the team at Liscio. They have also
              identified a client experience platform as an important unmet need
              for modern accounting firms and have championed a solution that
              addresses this need.
            </p>
            <p>
              Client Hub is more than just client experience. It is a unique
              solution built for your team and your clients. Your team can use
              Client Hub to manage your work, track deadlines and more. And you
              can work with your clients (in ways that are very similar to
              Liscio) all in one system.
            </p>
            <p>In short, we take Liscio to the next level.</p>

            <!-- 2 -->
            <!-- <h2>We’re like {{ appName }} in our focus on client experience.
              <br>We also integrate your workflow into that.
            </h2>
            <p>Client Hub and {{ appName }} were both launched in 2018 to fulfill a gap around client communication
              tools. We’ve both been pioneers in that space.
            </p>
            <p>Only Client Hub has gone on to add workflow and now offers a truly unique collaborative-workflow system.
              We’re a system that is designed from the ground up for both your internal team and your clients.</p>
            <p>Because your clients are part of your workflow, everything flows seamlessly. You’re never blocked
              “waiting for clients”. Client Hub is a modern, fresh, all-in-one platform: Workflow, Client Communication,
              Client Portal, File Sharing, Mobile Apps and more.</p> -->

            <!-- 3 -->
            <h3>So what sets Client Hub apart from {{ appName }}?</h3>
            <p>
              Here are six ways that Client Hub takes {{ appName }} to the next
              level.
            </p>

            <div class="features-items">
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/deadline.svg"
                    alt="Manage Deadlines"
                  />
                  <h3>Manage Deadlines</h3>
                  <p>
                    One-off and recurring jobs to easily track all client work.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/qbo-integration.svg"
                    class="qbo-icon"
                    alt="Unique QuickBooks Integration"
                  />
                  <h3>Unique QuickBooks Integration</h3>
                  <p>Instantly resolve uncategorized transactions.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/standardize-processes.svg"
                    alt="Standardize Processes"
                  />
                  <h3>Standardize Processes</h3>
                  <p>
                    Capture task details, so that anyone can pick up the work.
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/innovation.svg"
                    alt="Rapid Innovation"
                  />
                  <h3>Rapid Innovation</h3>
                  <p>
                    Always delighting customers with new capabilities based on
                    your input.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/secure-communication.svg"
                    alt="Secure Communication"
                  />
                  <h3>Secure Communication</h3>
                  <p>Email is just not secure. Don’t risk your firm.</p>
                </div>
                <div class="col-md-4">
                  <img
                    src="assets/img/landing-page-v4/comparisons/small-team.svg"
                    alt="Small Team, Personal Service"
                  />
                  <h3>Small Team, Personal Service</h3>
                  <p>You’re working with the founders.</p>
                </div>
              </div>
            </div>

            <div class="video-quote" style="margin: 64px 0">
              <div class="row">
                <div class="col-md-8">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/r9UdUu6aLak"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <p>April Miller, Sand Dollar Bookkeeping</p>
                </div>
                <div class="col-md-4">
                  <h2>
                    Hear about how Sand Dollar Bookkeeping’s client gets them
                    what they need through Client Hub -- and loves doing it!
                  </h2>
                </div>
              </div>
            </div>

            <!-- 4 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>Manage Deadlines for all your work</h3>
                  <p class="check-icon">
                    Client Hub tracks internal jobs and with our jobs dashboard,
                    your team doesn’t need a separate tool to manage your work
                    and deadlines.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, you only get half of our solution:
                    client collaboration. You still need to subscribe to a
                    workflow management tool like Karbon / JetPack / Financial
                    Cents.
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/jobs-dashboard.jpg"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 5 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>Workflow flowing across your team and clients</h3>
                  <p class="check-icon">
                    Client Hub’s unique approach allows you to set up a job that
                    includes both internal tasks and client tasks in one flow.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, managing your outstanding client tasks
                    is completely disconnected from managing the rest of the
                    work for that client engagement.
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/workflow.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 6 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6">
                  <h3>Standardize your Processes</h3>
                  <p class="check-icon">
                    With Client Hub’s capturing task steps and details, you can
                    standardize work and easily onboard new team members.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, there are no internal workflow
                    management tools.
                  </p>
                </div>
                <div class="col-md-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/description.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 7 -->
            <div class="check-x">
              <div class="row d-flex align-items-center">
                <div class="col-md-6 col-md-push-6">
                  <h3>Internal Collaboration Built-in</h3>
                  <p class="check-icon">
                    With Client Hub, your internal team can easily comment on
                    jobs (for internal communication) while completing work.
                  </p>
                  <p class="x-icon">
                    With {{ appName }}, there is no internal collaboration
                    capability -- communication is client-facing only.
                  </p>
                </div>
                <div class="col-md-6 col-md-pull-6">
                  <img
                    class="img-responsive"
                    style="max-height: 400px"
                    src="assets/img/landing-page-v4/comparisons/internal-collaboration.png"
                    alt="Image representing the clients list and staff"
                  />
                </div>
              </div>
            </div>

            <!-- 8 -->
            <h2>We’re simply a more collaborative and complete platform</h2>
            <h3 class="text-center">What we do…</h3>
            <div class="row">
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/client-hub.svg"
                  alt="Client Hub's features Chart"
                />
              </div>
              <div class="col-md-6">
                <img
                  class="img-responsive"
                  src="assets/img/landing-page-v4/comparisons/{{ app }}.svg"
                  alt="{{ appName }}'s features Chart"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h3 class="text-center" style="margin-bottom: 32px">
                  How We Do It…
                </h3>
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="text-center">Client Hub</h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/ch-experience.svg"
                      alt="Client Hub's Experience"
                    />
                  </div>
                  <div class="col-md-6">
                    <h4 class="text-center">
                      {{ appName }}
                    </h4>
                    <img
                      class="img-responsive"
                      src="assets/img/landing-page-v4/comparisons/{{
                        app
                      }}-experience.svg"
                      alt="{{ appName }}'s Experience"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="section-title text-center" style="margin-top: 80px">
              <h2>Save Big With Client Hub</h2>
              <p>
                Client Hub replaces a bunch of apps. See how our all-in-one
                solution compares to the cost (not to mention complexity) of
                bundling together a comparable “tech stack”.
              </p>
            </div>
            <div class="save-big text-left save-big-wrapper">
              <div class="row">
                <div class="col-md-5">
                  <div class="save-big-box-wrapper">
                    <div class="save-big-box no-plus">
                      <div class="icon">
                        <svg
                          width="41"
                          height="43"
                          viewBox="0 0 41 43"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M39.9505 5.4977C39.1937 1.78237 35.5732 -0.619247 31.8709 0.14024C28.1686 0.899726 25.7753 4.53295 26.5322 8.24827C26.6753 8.98723 26.9822 9.66461 27.3299 10.2804L24.6708 14.3242C23.3617 13.9957 21.9707 13.9136 20.5594 14.201C18.8616 14.55 17.4093 15.371 16.2229 16.4589L12.0501 13.6673C12.2138 12.8873 12.2138 12.0662 12.0501 11.2452C11.3751 7.94037 8.16372 5.8056 4.87049 6.48298C1.57726 7.18089 -0.550043 10.4036 0.124966 13.7084C0.799976 17.0132 4.01139 19.1479 7.30462 18.4706C8.12281 18.3063 8.87964 17.9779 9.51374 17.5263L13.6865 20.2974C13.1547 21.8164 12.9911 23.4996 13.3388 25.1828C13.707 27.0096 14.6274 28.5902 15.8547 29.8218L14.157 32.3876C13.4615 32.2234 12.7456 32.1824 11.9888 32.3261C9.1251 32.9213 7.26371 35.7335 7.83644 38.6277C8.42963 41.5015 11.2319 43.3694 14.1161 42.7947C16.9798 42.1994 18.8411 39.3872 18.2684 36.493C18.1252 35.7335 17.7775 35.0972 17.3479 34.5019L19.0457 31.9361C20.6616 32.5724 22.4617 32.8187 24.2821 32.4287C29.2936 31.4024 32.5459 26.476 31.5027 21.4469C31.2163 20.0306 30.6027 18.7785 29.764 17.6905L32.4232 13.6468C33.1391 13.7289 33.855 13.7289 34.5914 13.5852C38.3142 12.8462 40.7074 9.21303 39.9505 5.4977ZM6.52733 14.6731C5.3205 14.94 4.13411 14.1394 3.88866 12.9284C3.6432 11.7173 4.42048 10.5267 5.62732 10.2804C6.83415 10.0341 8.02053 10.8141 8.26599 12.0252C8.51145 13.2363 7.73417 14.4268 6.52733 14.6731ZM13.5024 39.7772C12.2751 40.0236 11.0888 39.2435 10.8433 38.0119C10.5978 36.7803 11.3751 35.5898 12.6024 35.3435C13.8297 35.0972 15.0161 35.8772 15.2615 37.1088C15.5275 38.3198 14.7297 39.5104 13.5024 39.7772ZM23.3617 27.9128C20.8253 28.426 18.3502 26.7839 17.8389 24.2385C17.3275 21.6932 18.9639 19.2095 21.5003 18.6963C24.0367 18.1832 26.5117 19.8253 27.0231 22.3706C27.5345 24.9159 25.8981 27.3997 23.3617 27.9128ZM33.7323 9.25408C32.4232 9.52093 31.1345 8.67933 30.8686 7.36563C30.6027 6.05192 31.4413 4.75874 32.7504 4.49189C34.0595 4.22505 35.3482 5.06664 35.6141 6.38035C35.88 7.69405 35.0414 8.98723 33.7323 9.25408Z"
                            fill="#0075FF"
                          />
                        </svg>
                      </div>
                      <div class="save-big-text">
                        <h4>Client Hub</h4>
                        <p>$49 - $59/month per user</p>
                      </div>
                    </div>
                    <div class="features">
                      <div class="plan-features">
                        <ul>
                          <li>Simple client messaging</li>
                          <li>Assign and track client tasks</li>
                          <li>QuickBooks categorization tasks</li>
                          <li>Secure client file-sharing</li>
                          <li>Manage Internal files</li>
                          <li>Client apps & resources</li>
                          <li>Mobile app access</li>
                          <li>Your firm branding</li>
                          <li>And much, much more…</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 text-center flex-center">
                  <div class="vs">VS</div>
                </div>
                <div class="col-md-6">
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.2924 0.419922C22.1431 0.419922 22.8319 1.11306 22.8319 1.96891V10.489L29.9988 3.27848C30.6004 2.67357 31.5748 2.67357 32.1766 3.27848C32.7776 3.88354 32.7776 4.86438 32.1766 5.46929L22.8319 14.8707V19.1274L34.7751 7.15781C35.3777 6.55359 36.3525 6.55537 36.9525 7.16179C37.5527 7.76808 37.5509 8.74837 36.9487 9.35247L22.8319 23.5005V28.014L38.0576 12.6953C38.659 12.0908 39.6337 12.0908 40.2351 12.6953C40.8364 13.3008 40.8364 14.2811 40.2351 14.8866L34.1681 20.991L40.2715 27.1319C40.8729 27.7369 40.8729 28.7177 40.2715 29.3226C39.9706 29.625 39.5765 29.7763 39.1829 29.7763C38.7887 29.7763 38.3946 29.625 38.0941 29.3226L31.9901 23.1818L29.5491 25.6381L36.7159 32.8487C37.3168 33.4537 37.3168 34.4344 36.7159 35.0395C36.4151 35.3417 36.0209 35.493 35.6268 35.493C35.233 35.493 34.8389 35.3417 34.538 35.0395L27.3713 27.8289L24.9302 30.2852L31.4921 36.8873C32.0931 37.4922 32.0931 38.473 31.4921 39.0781C31.1913 39.3803 30.7971 39.5317 30.403 39.5317C30.0093 39.5317 29.6152 39.3803 29.3143 39.0781L22.8319 32.5561V40.0309C22.8319 40.8864 22.1431 41.5799 21.2924 41.5799C20.4421 41.5799 19.7526 40.8864 19.7526 40.0309V1.96891C19.7526 1.11306 20.4421 0.419922 21.2924 0.419922V0.419922ZM15.1341 1.30486C15.9844 1.30486 16.6736 1.99841 16.6736 2.85385V39.1454C16.6736 40.001 15.9844 40.6946 15.1341 40.6946C14.2838 40.6946 13.5944 40.001 13.5944 39.1454V2.85385C13.5944 1.99841 14.2838 1.30486 15.1341 1.30486V1.30486ZM8.97549 4.84545C9.82578 4.84545 10.5151 5.53899 10.5151 6.39457V35.6049C10.5151 36.4603 9.82578 37.1539 8.97549 37.1539C8.1252 37.1539 7.43592 36.4603 7.43592 35.6049V6.39457C7.43592 5.53899 8.1252 4.84545 8.97549 4.84545V4.84545ZM2.81692 15.4675C3.66735 15.4675 4.35663 16.161 4.35663 17.0165V24.983C4.35663 25.8384 3.66735 26.532 2.81692 26.532C1.96663 26.532 1.27734 25.8384 1.27734 24.983V17.0165C1.27734 16.161 1.96663 15.4675 2.81692 15.4675Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Karbon (or JetPack/FinancialCents etc.): workflow</h4>
                      <p>$49 - $59/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/liscio.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Liscio: client communication and tasks</h4>
                      <p>$50/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg">
                    <div class="icon">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.5 3.1499L21 9.84365L10.5 16.5374L0 9.84365L10.5 3.1499V3.1499ZM31.5 3.1499L42 9.84365L31.5 16.5374L21 9.84365L31.5 3.1499V3.1499ZM0 23.2312L10.5 16.5374L21 23.2312L10.5 29.9249L0 23.2312V23.2312ZM31.5 16.5374L42 23.2312L31.5 29.9249L21 23.2312L31.5 16.5374V16.5374ZM10.5 32.1562L21 25.4624L31.5 32.1562L21 38.8499L10.5 32.1562Z"
                          fill="#3A4D97"
                        />
                      </svg>
                    </div>
                    <div class="save-big-text">
                      <h4>Dropbox for Teams (or Sharefile etc.): files</h4>
                      <p>$15/month per user</p>
                    </div>
                  </div>
                  <div class="save-big-box save-big-box-bg no-plus">
                    <div class="icon">
                      <img
                        class="img-responsive"
                        src="assets/img/uncat.png"
                        width="42"
                      />
                    </div>
                    <div class="save-big-text">
                      <h4>Uncat: QuickBooks uncategorized automation</h4>
                      <p>$5/month per client</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 9 -->
            <h2 class="text-center">We’ll help you evaluate and switch</h2>
            <p class="text-center">
              Get all your questions answered. Schedule a 1/1 demo
              <a (click)="openModal(demoScheduleModal)" target="_blank" rel="noreferrer noopener">here</a
              >.
            </p>

            <div class="row fix-mobile">
              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      SO THANKFUL<br />
                      <p style="font-weight: normal">CortnieG</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    The app is new, but they seem totally interested in making
                    it better and better! I have not even been a client a year
                    and I have had such a great experience overall!!!! I am
                    happy to call myself an excited and HAPPY customer and in
                    turn made a great experience for my firm. I highly recommend
                    it and would be willing to help anyone out if they had any
                    questions!! I cant wait to see what this product becomes!!
                    It is getting better and better as we go!!!!!!! (AND MY
                    CLEINTS LOVE IT TOO!)
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      EXACTLY what my firm needed<br />
                      <p style="font-weight: normal">eControllerPlus</p>
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I am blown away by this app! Everything at my fingertips and
                    everything at my clients' fingertips as well! I have moved
                    ALL client communications here and it couldn't be easier to
                    navigate our conversations. The ability to share docs with
                    clients and staff OR staff ONLY is brilliant. Wish I had
                    integrated this earlier!!
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-left">
                <div
                  class="testimonial d-flex align-items-center text-left"
                  style="align-items: flex-start; margin-top: 30px"
                >
                  <div class="testimonial-avatar-name">
                    <div class="strong">
                      <div
                        style="
                          color: #18b4ab;
                          font-size: 24px;
                          margin-bottom: 8px;
                        "
                      >
                        ★★★★★
                      </div>
                      THE best acct practice software on the market
                    </div>
                  </div>
                  <div class="testimonial-text">
                    I've been struggling for years to find the right combination
                    of software that would allow me and my team to manage all of
                    our bookkeeping clients from one location. The QuickBooks
                    team area works great for QuickBooks clients, but for all my
                    desktop/other accounting application clients, it just didn't
                    cut it. Client Hub does. With chat, file storage, QuickBooks
                    integration, and task lists as features, this has everything
                    I need to provide a full-service bookkeeping experience for
                    all my clients. Client Hub also allows you to "bookmark"
                    client-specific links - like to their banking applications,
                    third party software, and firm-developed applications.
                    Absolutely fantastic.
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center" style="margin-top: 30px">
              <div class="reviews-app row d-flex align-items-center">
                <div class="col-md-6 text-right">
                  <a
                    href="https://quickbooks.intuit.com/app/apps/appdetails/ClientHub/en-us//"
                    target="_blank" rel="noreferrer noopener"
                    class="btn btn-success"
                    >See all our app reviews</a
                  >
                </div>
                <div class="col-md-6 text-left">No Reviews Filtered Out</div>
              </div>
            </div>

            <!-- 10 -->
            <div class="big-cta orange">
              <div class="row">
                <div class="col-sm-3 col-md-3 cta-illustration">
                  <img
                    src="assets/img/landing-page-v4/billy-cta-2.png"
                    alt="Image of an accountant"
                  />
                </div>
                <div class="col-sm-5 col-md-6">
                  <div class="title">
                    Bring together Workflow and Collaboration!
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 text-right">
                  <button class="btn btn-orange" (click)="startRegistration()">
                    Start Trial
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Liscio -->
        </div>
      </div>
    </div>
  </section>
</main>
<app-footer></app-footer>
<ng-template #demoScheduleModal class="modal-lg">
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="modalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title" id="myModalLabel">Schedule meeting</h4>
  </div>
  <div
    class="modal-body"
    style="
      overflow: hidden;
      padding: 0;
      height: 87vh;
      background: url(assets/img/ajax-loader.gif) center center no-repeat;
    "
  >
    <iframe
      style="width: 100%; height: 100%"
      src="https://calendly.com/judiech/discussion?month=2020-01"
      frameborder="0"
    ></iframe>
  </div>
</ng-template>
<app-sign-up-drawer
  [signUpDrawerOpen]="signUpDrawerOpen"
  (signUpDrawerToggle)="signUpDrawerToggle($event)"
></app-sign-up-drawer>
